<template>
  <!-- 底部导航 -->
  <div>
    <!-- 个人信息 -->
    <div class="personal-con">
      <!-- 最新消息 -->
      <div class="nav-menu">
        <!-- <div class="pack-up"
               @click="messageShow=false"><i class="el-icon-arrow-right"></i></div> -->
        <div class="box1">
          <div class="avatar">
            <img :src="!userInfo.headPortrait ? '/images/default_avatar.png' : userInfo.headPortrait" alt="">
          </div>
          <div class="right" v-if="!token">
            <div class="login">请登录 / 注册</div>
          </div>
          <div class="right" v-else>
            <span class="name">{{ !userInfo.nickName ? '昵称' : 'Hi,' + userInfo.nickName }}</span>
            <!-- <button class="btn" :style="'background-color:' + themeColor" @click="logOut">退出</button> -->
          </div>
        </div>
        <!-- 余额 -->
        <div class="money">
          <div class="box" @click.stop="jumpWelfare">
            <span class="txt2">{{ !userInfo.welfarePoint ? '0.00' : userInfo.welfarePoint }}</span>
            <span class="txt1">福利卡余额</span>
          </div>
          <div class="box" @click.stop="jumpSpecialZone">
            <span class="txt2">{{ specialZoneList && specialZoneList.length > 0 ? specialZoneList[0].integral : '0.00'
            }}</span>
            <span class="txt1">专区余额</span>
          </div>
          <div class="box" @click.stop="jumpCenterPage(5)">
            <span class="txt2">{{ info.favoriteCount || 0 }}</span>
            <span class="txt1">收藏</span>
          </div>
        </div>
        <img src="/images/index/line.png" class="money-line" alt="" />
        <!-- 选项 -->
        <div class="other-box">
          <div class="other_item" @click.stop="jumpCenterPage(1)" style="background: #FFDCDB;border-radius: 4px;">
            <img src="/images/index/icon1.png" alt="">
            <div style="color: #FF1D18;">个人中心</div>
          </div>
          <div class="other_item" @click.stop="jumpCenterPage(2)">
            <img src="/images/index/icon2.png" alt="">
            <div>我的订单</div>
          </div>
          <!-- <div class="other_item"
                 @click.stop="jumpCenterPage(3)">
              <img src="/images/home_icon2.png"
                   alt="">
              <div>福利卡</div>
            </div> -->
          <div class="other_item" @click.stop="jumpCenterPage(4)">
            <img src="/images/index/icon3.png" alt="">
            <div>消息通知</div>
          </div>
          <div class="other_item" @click.stop="jumpCenterPage(5)">
            <img src="/images/index/icon4.png" alt="">
            <div>我的收藏</div>
          </div>
          <div class="other_item" @click.stop="jumpCenterPage(6)">
            <img src="/images/index/icon5.png" alt="">
            <div>浏览记录</div>
          </div>
          <div class="other_item" @click.stop="jumpCenterPage(7)">
            <img src="/images/index/icon6.png" alt="">
            <div>收货地址</div>
          </div>
        </div>
        <img src="/images/index/line.png" class="money-line" alt="" />
        <div class="box2">
          <div class="nav">
            <span class="nav-tit">最新公告</span>
            <div class="nav-more" style="display: flex;align-items: center;" @click="jumpNotice">
              <span>更多></span>
            </div>
          </div>
          <div class="center">
            <div class="message" v-for="(item, index1) in noticeList1" :key="index1" v-show="index1 == 0">
              <span class="label">公告</span>
              <div class="word">{{ item.title }}</div>
            </div>
            <!-- <div class="message">
              <span class="word2"
                    v-for="(item,index2) in noticeList2"
                    :key="index2">{{ item.title }}</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  data() {
    return {
      userInfo: {},//个人信息
      noticeList1: [],//最新通知
      token: '',
      info: {},//个人信息
      specialZoneList: [],//专区数据
    }
  },
  mounted() {
    this.token = localStorage.getItem('wckj-Token')
    if (localStorage.getItem('wckj-Token')) {
      // this.getActivity()
      this.getUserInfo()
      this.getSpecialZoneList()
    }
    this.getNotice()
  },
  methods: {
    // 获取最新公告
    async getNotice() {
      await this.$api.mall.getNotice({
        releasePc: 1
      }).then((res) => {
        console.log(res, '最新公告');
        if (res.code == 200) {
          let data = res.data
          if (data.lenth <= 3) {
            this.noticeList1 = data
          } else {
            data.forEach((item, index) => {
              if (index < 3) {
                this.noticeList1.push(item)
              } else {
                this.noticeList2.push(item)
              }
            })
          }
        }
      });
    },
    // 获取个人信息
    async getUserInfo() {
      await this.$api.mall.getInfo().then((res) => {
        console.log(res, '个人信息');
        if (res.code == 200) {
          this.userInfo = res.data.userInfo
          this.info = res.data;
        }
      });
    },
    jumpCenterPage(type) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (type == 1) {
        this.$store.dispatch('saveMessageType', '')
        this.$store.dispatch('savePersonType', '')
        this.$router.push('/userInfo');
      } else if (type == 2) {
        this.$store.dispatch('savePersonType', 1)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/orderList');
      } else if (type == 3) {
        this.$store.dispatch('savePersonType', 3)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/benefitCard');
      } else if (type == 4) {
        this.$store.dispatch('saveMessageType', 1)
        this.$store.dispatch('savePersonType', '')
        this.$router.push('/messageList');
      } else if (type == 5) {
        this.$store.dispatch('savePersonType', 9)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/collectRecord');
      } else if (type == 6) {
        this.$store.dispatch('savePersonType', 10)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/browseRecord');
      } else if (type == 7) {
        this.$store.dispatch('savePersonType', 6)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/addressList');
      }
    },
    // 获取专区数据
    getSpecialZoneList() {
      this.$api.mall.userActivityIntegralList({
        pageNum: 1,
        pageSize: 1,
        cardType: 0
      }).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.specialZoneList = res.rows
        }
      })
    },
    // 跳转专区
    async jumpSpecialZone() {
      this.$store.dispatch('savePersonType', 22)
      this.$store.dispatch('saveMessageType', '')
      this.$router.push('/specialZone')
    },
    // 跳转更多信息
    jumpNotice() {
      this.$router.push('/noticeList')
    },
    // 跳转福利卡
    jumpWelfare() {
      this.$router.push('/benefitCard')
    },
  }
};
</script>

<style lang="scss" scoped>
.personal-con {
  height: 441px;
  background: linear-gradient( 182deg, #FFE2E0 0%, #FFFFFF 40%, #FFFFFF 100%);
  border-radius: 10px;
  padding: 12px 16px 0;
  box-sizing: border-box;

  .nav-menu {
    .pack-up {
      width: 25px;
      height: 50px;
      background-color: #fff;
      position: absolute;
      left: -25px;
      top: calc(50% - 25px);
      z-index: 5;
      font-size: 22px;
      border-radius: 30px 0 0 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .box1 {
      width: 100%;
      height: 43px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .avatar {
        width: 43px;
        height: 43px;
        border-radius: 100%;
        overflow: hidden;

        img {
          width: 43px;
          height: 43px;
          display: inline-block;
        }
      }

      .right {
        flex: 1;
        height: 54px;
        padding-left: 12px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .name {
          width: 100%;
          font-size: 16px;
          color: #1F1F1F;
        }

        .btn {
          width: 58px;
          height: 26px;
          background-color: #004098;
          border-radius: 13px;
          text-align: center;
          line-height: 26px;
          font-size: 12px;
          color: #fff;
        }

        .login {
          line-height: 54px;
          font-size: 12px;
          color: #FF1D18;
        }
      }
    }

    .money {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 18px 0 0;
      box-sizing: border-box;


      .box {
        flex: 1;
        height: 38px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .txt1 {
          font-size: 12px;
          color: #666666;
        }

        .txt2 {
          display: inline-block;
          height: 22px;
          font-size: 16px;
          color: #1F1F1F;
          font-weight: bold;
          line-height: 22px;
        }
      }
    }

    .money-line {
      width: 100%;
      height: 6px;
      margin: 14px 0 14px;
    }

    .other-box {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fill, 33.33%);
      justify-content: space-between;
      grid-row-gap: 6px;

      // margin-top: 20px;
      .other_item {
        width: 100%;
        height: 53px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          width: 20px;
        }

        div {
          font-size: 12px;
          color: #666666;
          line-height: 17px;
          margin-top: 6px;
        }
      }
    }

    .line {
      width: 100%;
      height: 1px;
      border-top: 1px dashed #ECECEC;
      margin: 15px 0;
    }

    .box2 {
      width: 100%;

      .nav {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        box-sizing: border-box;

        .nav-tit {
          font-size: 14px;
          color: #333333;
          font-weight: bold;
        }

        .nav-more {
          font-size: 12px;
          color: #999999;
        }
      }

      .center {
        width: 100%;
        margin-top: 8px;
        box-sizing: border-box;
        position: relative;

        .message {
          width: 100%;
          display: flex;
          align-items: center;
          // justify-content: flex-start;
          margin-top: 8px;
          padding-right: 20px;
          box-sizing: border-box;

          .label {
            display: inline-block;
            width: 35px;
            height: 18px;
            background: rgba(255, 186, 191, 0.36);
            border-radius: 4px;
            text-align: center;
            line-height: 18px;
            font-size: 12px;
            color: #FF1D18;
          }

          .word {
            flex: 1;
            display: inline-block;
            font-size: 12px;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            word-break: break-all;
            margin-left: 10px;

          }

          >img {
            width: 26px;
          }

          .word:first-child {
            margin-top: 0;
          }

          .word2 {
            flex: 1;
            display: inline-block;
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 12;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }
        }

        .message:first-child {
          margin-top: 0;
        }
      }
    }
  }
}
</style>